<script>
    import { link, location } from 'svelte-spa-router'
    import { t } from '../i18n.js'
    import LogInOutButton from '../components/LogInOutButton.svelte'
    import LangSelect from '../components/LangSelect.svelte'
    import CloseIcon from '../assets/icons/CloseIcon.svelte'
    import MenuIcon from '../assets/icons/MenuIcon.svelte'
    import { isMobile } from '../store/stores.js'
    import { fade } from 'svelte/transition'

    const navObjects = [
        {
            title: 'nav.home',
            path: '/'
        },
        {
            title: 'nav.interfaces',
            path: '/interfaces'
        },
        {
            title: 'nav.import-interfaces',
            path: '/interfaces-import'
        },
        {
            title: 'nav.info',
            path: '/info'
        }
    ]

    $: currentLocation = $location.split('/')[1]

    let mobileMenuOpen = false

    function toggleMobileMenu() {
        mobileMenuOpen = !mobileMenuOpen
    }

    function closeMenu() {
        mobileMenuOpen = false
    }
</script>

<div class="p-6 bg-navy shadow-lg z-30 fixed w-full">
    <div class="container flex justify-between items-center">
        <a href="/" use:link>
            <img src="img/datajalostamo-logo.png" alt="{$t('nav.logo-alt')}" class="w-32">
        </a>
        {#if $isMobile}
            <button
                type="button"
                aria-label="{mobileMenuOpen ? $t('navbar.close-menu-aria') : $t('navbar.open-menu-aria')}"
                on:click={toggleMobileMenu}
                class="w-12 h-12 rounded-lg bg-white flex justify-center items-center">
                {#if mobileMenuOpen}
                    <CloseIcon color={'navy'} />
                {:else}
                    <MenuIcon color={'navy'} />
                {/if}
            </button>
        {:else}
            <nav class="text-white uppercase">
                {#each navObjects as navObj}
                    <a href="{navObj.path}" use:link class="mr-10 font-semibold last:mr-0 hover:text-lighter-blue transition duration-150 {navObj.path === `/${currentLocation}` ? 'after:block after:absolute after:-inset-[2.4rem] after:top-[3.5rem] after:w-14 after:mx-auto after:bg-light-blue relative inline-block' : ''}">{$t(navObj.title)}</a>
                {/each}
            </nav>
            <div class="flex">
                <div class="mr-8">
                    <LogInOutButton />
                </div>
                <LangSelect />
            </div>
        {/if}
    </div>
</div>
{#if mobileMenuOpen}
    <div transition:fade="{{duration: 100}}" class="bg-navy text-right fixed top-24 left-0 right-0 z-30">
        <nav class="text-white uppercase flex flex-col my-8">
            {#each navObjects as navObj}
                <a href="{navObj.path}" use:link on:click={toggleMobileMenu} class="py-4 pr-8 hover:text-lighter-blue transition duration-150 {navObj.path === $location ? 'border-r-8 border-white' : ''}">{$t(navObj.title)}</a>
            {/each}
        </nav>
        <div class="m-8">
            <LogInOutButton on:clicked={closeMenu} />
        </div>
        <div class="m-8">
            <LangSelect on:clicked={closeMenu} />
        </div>
    </div>
{/if}